import { get, isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Fade from 'components/Fade';
import { SenaryHeading } from 'components/Headings';
import CartUpsell from 'models/CartUpsell';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

import Placeholder from './Placeholder';
import Upsell from './Upsell';

const CartUpsellV2 = class extends React.PureComponent {
  static propTypes = {
    cartUpsells: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.instanceOf(CartUpsell))).isRequired,
    recommendationPairingNames: PropTypes.arrayOf(PropTypes.string),
    isLoading: PropTypes.bool,
    onMount: PropTypes.func,
    addToCart: PropTypes.func,
    trackEvent: PropTypes.func,
    uiEnhancementsEngagement: PropTypes.shape({
      dyDecisionId: PropTypes.string,
      dyVariationId: PropTypes.number,
    }),
  };

  static defaultProps = {
    isLoading: true,
    recommendationPairingNames: [],
    onMount: () => {},
    addToCart: () => {},
    trackEvent: () => {},
    uiEnhancementsEngagement: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      recommendationIndex: 0,
    };
  }

  componentDidMount() {
    // Strange bug where firing something onMount breaks the transition group and makes the cart not slide open. Addin a timeout "fixes" the symptom.
    setTimeout(this.props.onMount, Theme.get('transition-duration'));
  }

  // We grab the first index because product name and type will be the same across colorways
  get productName() {
    return get(this.props.cartUpsells, [this.state.recommendationIndex, '0', 'productName']);
  }

  get productType() {
    return get(this.props.cartUpsells, [this.state.recommendationIndex, '0', 'productType']);
  }

  updateRecommendation = () => {
    this.setState(prevState => ({
      recommendationIndex: prevState.recommendationIndex + 1,
    }));
  };

  render() {
    const {
      cartUpsells,
      recommendationPairingNames,
      addToCart,
      isLoading,
      trackEvent,
      uiEnhancementsEngagement,
    } = this.props;

    // Bail early if API doesn't respond or if we went through all upsells
    if (isEmpty(cartUpsells) || this.state.recommendationIndex >= cartUpsells.length) return null;

    return isLoading ? (
      <Placeholder />
    ) : (
      <div className="CartUpsellV2">
        <SenaryHeading className="CartUpsellV2__header">
          {I18n.localize('upsells.youMightAlsoLike')}
        </SenaryHeading>
        <Fade show>
          <Upsell
            productName={this.productName}
            recommendedItems={cartUpsells[this.state.recommendationIndex]}
            recommendationPairingName={recommendationPairingNames[this.state.recommendationIndex]}
            productType={this.productType}
            addToCart={addToCart}
            updateRecommendation={this.updateRecommendation}
            trackEvent={trackEvent}
            uiEnhancementsEngagement={uiEnhancementsEngagement}
          />
        </Fade>
        <style jsx global>
          {`
            .typography--senary-heading.CartUpsellV2__header {
              margin-bottom: ${Theme.get('spacing') * 2}px;
            }
          `}
        </style>
      </div>
    );
  }
};

export default CartUpsellV2;
